import { useEffect } from "react";
import { useState } from "react";
import { SECURE_COOKIE } from "@globalConfig";
import useCookieClient from "@hooks/useCookieClient";
import { checkTestFlag } from "@/common/config/websiteConfig";
import { getUniversalCookieValue } from "@/utils/GlobalJavascriptFunction";
var COOKIE_NAME = "hide_gtm_v1";
function getLocationParams(search) {
  return new URLSearchParams(search);
}
export default function useHideGTM(req) {
  if (__IS_SSR__) {
    return req && !!getUniversalCookieValue(req, COOKIE_NAME, false);
  }
  var params = getLocationParams(location.search);
  var _useState = useState(!!params.get("hideGtm") || !!params.get("webview")),
    hideGTM = _useState[0],
    setHideGTM = _useState[1];
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient,
    setCookieClient = _useCookieClient.setCookieClient;
  useEffect(function () {
    if (checkTestFlag("TEST_HIDE_GTM") !== undefined) {
      return setHideGTM(checkTestFlag("TEST_HIDE_GTM"));
    }
    var cookieValue = getCookieClient(COOKIE_NAME);
    if (cookieValue === "1") {
      setHideGTM(true);
    } else if (hideGTM) {
      setCookieClient(COOKIE_NAME, "1", {
        path: "/",
        maxAge: 3600 * 24 * 365 * 10,
        sameSite: true,
        secure: SECURE_COOKIE
      });
    }
  }, [hideGTM]);
  return hideGTM;
}